import React from 'react';
import { useLocation } from 'react-router-dom';

// Helper function to convert path to Title Case
const titleizePath = (path) => {
  return path
    .replace(/^\/|\/$/g, '') // remove leading/trailing slashes
    .split('/') // split by slashes
    .map(segment =>
      segment
        .split('-') // split kebab-case
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each word
        .join(' ')
    )
    .join(' / '); // join path segments with " / "
};

const DashboardReady = () => {
  const location = useLocation();
  const path = location.pathname;
  const titlePath = titleizePath(path);

  return (
    <div className="dashboard-ready-container">
      <div className="dashboard-ready-card">
        <div className="icon-wrapper">
          <i className="bi bi-rocket-takeoff-fill launch-icon"></i>
        </div>
        <h2 className='kpi-heading'>Preparing Your {titlePath || 'Dashboard'}</h2>
        <p className="message kpi-name">
          We're currently loading all your data and settings. This may take a few moments.
        </p>
        <div className="loader"></div>
        <small className="text-muted-dashboardready">
          Hang tight — everything will be ready shortly.
        </small>
        <small className="text-muted-dashboardready">
          Thank you for your patience!
        </small>
      </div>
    </div>
  );
};

export default DashboardReady;
